import { render, staticRenderFns } from "./UserAssignCompany.vue?vue&type=template&id=6d95fd36"
import script from "./UserAssignCompany.vue?vue&type=script&lang=js"
export * from "./UserAssignCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports